import React, { ComponentType } from 'react'
import { IFixedObject } from 'gatsby-background-image'

import { Header } from '../Header/Header'

export type BoxHrefProps = {
  link: string
}

export type BoxImage = {
  url?: string
  fixed?: IFixedObject
  target?: string
}

export type BoxLinkProps = {
  title: string
  link: BoxHrefProps
  target?: string
}
export type BoxButtonProps = {
  cta: string
  link: BoxHrefProps
  target?: string
}

export type BoxProps = {
  fullHeight?: boolean
  button?: BoxButtonProps
  header: BoxLinkProps
  image?: BoxImage
  renderLink?: ComponentType<BoxRenderLinkProps>
  renderButton?: ComponentType<BoxRenderButtonProps>
}

export type BoxRenderLinkProps = BoxLinkProps
export type BoxRenderButtonProps = BoxButtonProps

const renderLinkDefault = ({ link, title, target }: BoxRenderLinkProps) => (
  <a href={link.link} target={target || '_self'}>
    {title}
  </a>
)
const renderButtonDefault = ({ link, cta, target }: BoxRenderButtonProps) => {
  if (link && link.link && cta) {
    return (
      <a
        href={link.link}
        className="button button--6-2"
        target={target || '_self'}
      >
        {cta}
      </a>
    )
  }
  return null
}

const boxClass = (
  fullHeight: boolean,
  button?: BoxRenderButtonProps,
  image?: BoxImage
) => {
  if (fullHeight) {
    return 'box box--2'
  }
  if (image) {
    return 'box box--3 bg--img bg--blend'
  }
  if (!fullHeight || !button) {
    return 'box box--1'
  }

  return ''
}

const renderBackground = (image?: BoxImage) => {
  if (image && image.url) {
    return {
      backgroundImage: `url(${image.url}), linear-gradient(108deg, #3e5151 0%,#decba4 100%)`
    }
  }
  if (image && image.fixed) {
    return {
      backgroundImage: `url(${image.fixed.src}), linear-gradient(108deg, #3e5151 0%,#decba4 100%)`
    }
  }
  if (image && !image.url) {
    return {
      backgroundColor: `#171721`
    }
  }
  return {}
}

export const Box = ({
  fullHeight = false,
  button,
  header,
  image,
  renderLink: Link = renderLinkDefault,
  renderButton: Button = renderButtonDefault
}: BoxProps) => (
  <div
    className={boxClass(fullHeight, button, image)}
    style={renderBackground(image)}
  >
    <Header level={4} className={fullHeight ? 'heading--4' : 'heading--5'}>
      <Link {...header} />
    </Header>

    {fullHeight && button && button.cta && (
      <div className="button__wrapper button__wrapper--1">
        <Button {...button} />
      </div>
    )}
  </div>
)
export default Box
